module.exports = __webpack_public_path__ + "static/img/id_front.212e03a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/id_front.png
// module id = cAv+
// module chunks = 1